import * as types from '../types/cartTypes';
import { CART_STORAGE_KEY, CART_SESSION_STORAGE_KEY } from '../constants/storageKeys';

function newSessionId() {
  try {
    if (typeof crypto !== 'undefined' && typeof crypto.randomUUID === 'function') {
      return crypto.randomUUID();
    }
  } catch {
    /* ignore */
  }
  return `s_${Date.now()}_${Math.random().toString(36).slice(2, 14)}`;
}

function loadItemsFromStorage() {
  try {
    const raw = localStorage.getItem(CART_STORAGE_KEY);
    const parsed = raw ? JSON.parse(raw) : [];
    return Array.isArray(parsed) ? parsed : [];
  } catch {
    return [];
  }
}

function loadSessionIdFromStorage() {
  try {
    const s = localStorage.getItem(CART_SESSION_STORAGE_KEY);
    return s && String(s).length >= 8 ? String(s) : null;
  } catch {
    return null;
  }
}

const initialState = {
  items: loadItemsFromStorage(),
  drawerOpen: false,
  cartSessionId: loadSessionIdFromStorage(),
};

const cartReducer = (state = initialState, action) => {
  switch (action.type) {
    case types.CART_ENSURE_SESSION: {
      if (state.cartSessionId) return state;
      return { ...state, cartSessionId: newSessionId() };
    }
    case types.CART_OPEN_DRAWER:
      return { ...state, drawerOpen: true };
    case types.CART_CLOSE_DRAWER:
      return { ...state, drawerOpen: false };
    case types.CART_ADD_LINE: {
      const { product, size, color, qty = 1 } = action.payload || {};
      if (!product?.id) return state;
      let cartSessionId = state.cartSessionId;
      if (!cartSessionId) cartSessionId = newSessionId();
      const n = Number(qty);
      const addQty = Number.isFinite(n) && n > 0 ? Math.floor(n) : 1;
      const idx = state.items.findIndex(
        (i) => i.product?.id === product.id && i.size === size && i.color === color,
      );
      let items;
      if (idx >= 0) {
        items = [...state.items];
        items[idx] = { ...items[idx], qty: items[idx].qty + addQty };
      } else {
        items = [...state.items, { product, size, color, qty: addQty }];
      }
      return { ...state, cartSessionId, drawerOpen: true, items };
    }
    case types.CART_REMOVE_LINE_AT_INDEX: {
      const i = action.payload;
      if (typeof i !== 'number' || i < 0 || i >= state.items.length) return state;
      const items = [...state.items];
      items.splice(i, 1);
      return { ...state, items };
    }
    case types.CART_SET_LINE_QTY_AT_INDEX: {
      const { index: i, qty } = action.payload || {};
      if (typeof i !== 'number' || i < 0 || i >= state.items.length) return state;
      const q = Number(qty);
      const items = [...state.items];
      items[i] = {
        ...items[i],
        qty: Math.max(1, Number.isFinite(q) ? Math.floor(q) : 1),
      };
      return { ...state, items };
    }
    case types.CART_CLEAR:
      return { ...state, items: [] };
    default:
      return state;
  }
};

export default cartReducer;
